import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import localStorage from 'utils/bom-dom-manipulation/local-storage';
import {
  CONFIRM_MODAL_PADDING,
  CONFIRM_MODAL_WIDTH
} from 'utils/constants/account/payment';
import { ZINDEX_TOOLTIP } from 'utils/constants/app/ui';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { storageKeyName } from 'utils/generic/storage-key-name';
import { Modal, ModalButtons } from 'components/Modal';
import { Button } from 'newcomponents/UI/Button';
import './index.less';

export const AgePopup = (): ReactElement => {
  const { t } = useTranslation();
  const ENOUGH_OLD = localStorage.getItem(storageKeyName('app', 'ENOUGH_OLD'));
  const [visible, setVisible] = useState(!JSON.parse(ENOUGH_OLD));

  const [visibleNotEnoughOld, setVisibleNotEnoughOld] = useState(false);

  return (
    <Modal
      visible={visible}
      title={
        visibleNotEnoughOld
          ? t('generic.notEnoughOldTitle')
          : t('generic.verifyAge')
      }
      align="center"
      image={{
        lib: 'generic',
        name: 'attentiongeneric',
        theme: 'colored'
      }}
      padding={CONFIRM_MODAL_PADDING._0}
      width={CONFIRM_MODAL_WIDTH._420}
      centered
      renderInBody
      onCancel={() => setVisible(false)}
      zIndex={ZINDEX_TOOLTIP}
      closable={false}
      maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.88)', zIndex: 10000 }}
    >
      <span
        className={
          visibleNotEnoughOld ? 'notEnoughOldInfo__text' : 'verifyAge__text'
        }
        dangerouslySetInnerHTML={{
          __html: visibleNotEnoughOld
            ? t('generic.notEnoughOld')
            : t('generic.minAgeInfo')
        }}
      />
      {!visibleNotEnoughOld && (
        <ModalButtons>
          <Button
            type="cancel"
            size="large"
            onClick={() => {
              setVisibleNotEnoughOld(true);
            }}
          >
            {t('account.no')}
          </Button>
          <Button
            style={{
              [`margin${SpringConfigs.IS_RTL ? 'Right' : 'Left'}`]: '8px'
            }}
            type="primary"
            size="large"
            onClick={() => {
              localStorage.setItem(storageKeyName('app', 'ENOUGH_OLD'), 'true');
              setVisible(false);
            }}
          >
            {t('account.yes')}
          </Button>
        </ModalButtons>
      )}
    </Modal>
  );
};
